import { Component, OnInit } from '@angular/core';
import { FlowTemplateService } from '../../services/flow-template.service';
import { ActivatedRoute } from '@angular/router';
import { SubHeaderService } from '../../../core/services/sub-header.service';
import { SubHeader } from "../../../core/models/sub-header.model";
import { LoaderService } from '../../../common/services/loader.service';

@Component({
    selector: 'app-workflow-import',
    templateUrl: './workflow-import.component.html',
    styleUrls: ['./workflow-import.component.scss'],
    standalone: false
})
export class WorkflowImportComponent implements OnInit {
  moduleGroupId: string;
  moduleId: string;
  importAsNewFlow: boolean = false;
  newFlowName: string = "";
  files: any[];
  uploadFileName: string = "";
  public subHeader = new SubHeader({ title: "Workflow Import" });

  constructor(public readonly service: FlowTemplateService,
              public readonly route: ActivatedRoute,
              public readonly subHeaderService: SubHeaderService,
              public readonly loader: LoaderService) {
    subHeaderService.updateSubHeader(this.subHeader);
  }

  ngOnInit() {
    this.moduleGroupId = (this.route.snapshot.params.moduleGroupId !== undefined)
      ? this.route.snapshot.params.moduleGroupId
      : null;
    this.moduleId = (this.route.snapshot.params.moduleId !== undefined)
      ? this.route.snapshot.params.moduleId
      : null;
  }

  fileChanged(files): void {
    this.uploadFileName = ":" + files[0].name;
    this.files = files;
  }

  upload() {
    this.loader.toggleLoader(true);
    this.service.importTemplate(this.files[0], this.importAsNewFlow, this.newFlowName, this.moduleGroupId, this.moduleId)
      .subscribe(s => {
        this.loader.toggleLoader(false);
        alert("success");
      });
  }
}
